import UeberUns from './components/ueber-uns.vue';
import Infothek from './components/infothek.vue';
import Impressum from './components/impressum.vue';
import Aktuelles from './components/aktuelles.vue';
import Angebote from './components/angebote.vue';
import Login from './components/login.vue';
import AdminOverview from './components/admin-overview.vue';
import AdminNew from './components/admin-new.vue';

const routes = [
    { path: '/', component: Aktuelles},
    { path: '/ueber-uns', component: UeberUns},
    { path: '/infothek', component: Infothek },
    { path: '/impressum', component: Impressum },
    { path: '/angebote', component: Angebote },
    { path: '/login', component: Login },
    { path: '/admin', component: AdminOverview, meta: {requiresAuth: true}},
    { path: '/adminNew', component: AdminNew, meta: {requiresAuth: true}},
];

export default routes;